import styled from 'styled-components';

export const SettingsWrapperStyled = styled.div`
    display: flex;
    flex-direction: column;
    
`;

export const BackStyled = styled.div`
    
    & > button {
        background: none;
        outline: none;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px;
        border-radius: 10px;
        transition: .3s ease all;

        & > span {
        color: #FF5733;
        font-family: 'Rubik', sans-serif;
        font-size: 20px;

        &:nth-child(1) {
            margin: 0px 10px 0px 0px;

            @media screen and (max-width: 576px){
                margin: 0px;
            }
        }

        &:nth-child(2) {
            @media screen and (max-width: 576px){
                display: none;
            }
        }

        }

        &:hover {
            background-color: ${function() {
            switch(localStorage.getItem('theme')) {
                case 'dark':
                    return '#414141';
                    break;
                case 'light':
                    return '#E7D5C6';
                    break;
                default:
                    return '#E7D5C6';
            }
        }};
        }
    }
`;

export const SettingsMainStyled = styled.div`
    display: flex;
    flex-direction: column;
`;

export const InfoStyled = styled.div`
    align-self: center;
    display: flex;
    align-items: center;

    & > span {
        &:nth-child(1) {
            color: #f0a000;
            font-size: 25px;
            margin: 0px 10px 0px 0px;

            @media screen and (max-width: 576px){
                font-size: 20px;
            }
        }

        &:nth-child(2) {
            font-size: 20px;
            color: ${function() {
            switch(localStorage.getItem('theme')) {
                case 'dark':
                    return '#bebebe';
                    break;
                case 'light':
                    return '#858585';
                    break;
                default:
                    return '#858585';
            }
        }};

            @media screen and (max-width: 576px){
                font-size: 18px;
            }
        }
    }

    @media screen and (max-width: 992px){
        margin: 30px 0px 0px 0px;
    }
`;

export const MainStyled = styled.div`
    margin: 40px 0px 0px 0px;
`;

export const LanguageSelectStyled = styled.div`
    & > span {
        display: inline-block;
        margin: 0px 0px 5px 0px;
        font-weight: 500;

        &:nth-child(1) {
            color: ${function() {
            switch(localStorage.getItem('theme')) {
                case 'dark':
                    return 'white';
                    break;
                case 'light':
                    return 'black';
                    break;
                default:
                    return 'black';
            }
        }};
        }

        @media screen and (max-width: 576px){
            margin: 0px 0px 10px 0px;
        }
    }

    & > div {
        width: 100%;
        max-width: 265px;

        @media screen and (max-width: 576px){
            max-width: 100%;
        }
    }
`;

export const ThemeSelectStyled = styled(LanguageSelectStyled)`
    margin: 25px 0px 0px 0px;
`;